import { render } from "./MapView.vue?vue&type=template&id=b74f27b8&scoped=true&bindings={\"sections\":\"data\"}"
import script from "./MapView.vue?vue&type=script&lang=js"
export * from "./MapView.vue?vue&type=script&lang=js"

import "./MapView.vue?vue&type=style&index=0&id=b74f27b8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b74f27b8"

export default script